import api from '@/common/api';

const initialState = () => ({
  services: [],
  serviceCreating: false,
  serviceCreatingDetails: [],
  serviceDetailPreview: {},
  loading: false,
  stepCreating: [],
  currentStepCreating: 'InitializationCreating',
  stepsCreating: [
    {
      id: 0,
      name: 'InitializationCreating',
      text: 'Инициализация создания карточки услуги',
      status: 'notStarted', // [notStarted,started,finished,error]
      detailError: [],
    },
    {
      id: 1,
      name: 'createBaseCard',
      text: 'Создание базовой карточки',
      status: 'notStarted', // [notStarted,started,finished,error]
      detailError: [],
    },
    {
      id: 2,
      name: 'createModules',
      text: 'Создание модулей',
      status: 'notStarted', // [notStarted,started,finished,error]
      modules: [
        {
          id: 0,
          availability: true,
          name: 'main_image',
          text: 'Модуль главного изображения',
          status: 'notStarted',
          error: [],
        },
        {
          id: 1,
          availability: true,
          name: 'features',
          text: 'Модуль особенностей',
          status: 'notStarted',
          error: [],
        },
        {
          id: 2,
          availability: true,
          name: 'contact_button',
          text: 'Модуль контактной кнопки',
          status: 'notStarted',
          error: [],
        },
        {
          id: 3,
          availability: true,
          name: 'report_preview',
          text: 'Модуль превью',
          status: 'notStarted',
          error: [],
        },
      ],
      detailError: [],
    },
    {
      id: 3,
      name: 'finished',
      text: 'Финиш',
      status: 'notStarted', // [notStarted,started,finished,error]
      detailError: [],
    },
  ],
  baseFieldService: [
    {
      id: 1,
      type: 'input',
      field: 'mainTitle',
      widthContainer: '100%',
      placeholder: 'Введите название заголовка',
      actions: ['update', 'delete'],
      inputValue: '',
      inputWidth: '600px',
      inputHeight: '50px',
      inputAppendText: '',
      inputAppendIcon: '',
      btnInner: false,
      btnInnerTitle: '',
      btnSlot: false,
      cards: [],
      validation: {
        required: true,
        minLength: 3,
        maxLength: 1000
      },
    },
    {
      id: 2,
      type: 'input',
      field: 'shortDescription',
      widthContainer: '63%',
      placeholder: 'Добавьте краткое описание',
      actions: ['draggable', 'update', 'delete'],
      inputValue: '',
      inputWidth: '600px',
      inputHeight: '82px',
      inputAppendText: '',
      inputAppendIcon: '',
      btnInner: false,
      btnInnerTitle: '',
      btnSlot: true,
      inputType: 'textarea',
      cards: [],
      validation: {
        required: true,
        minLength: 3,
        maxLength: 1000
      },
    },

    {
      id: 4,
      field: 'mainImage',
      widthContainer: '35%',
      placeholder: '',
      actions: ['update', 'delete'],
      inputValue: '',
      inputWidth: '',
      inputHeight: '',
      inputAppendText: '',
      inputAppendIcon: '',
      btnInner: false,
      btnInnerTitle: '',
      mainImage: { },
      mainImageBase64: '',
      btnSlot: false,
      type: 'upload',
      validation: {
        type: 'mainImage',
      },
    },
    {
      id: 5,
      field: 'fullDescription',
      widthContainer: '100%',
      placeholder: 'Добавьте подробное описание',
      actions: ['draggable', 'update', 'delete'],
      inputValue: '',
      inputWidth: '776px',
      inputHeight: '82px',
      inputAppendText: '',
      inputAppendIcon: '',
      inputType: 'textarea',
      btnInner: false,
      btnInnerTitle: '',
      btnSlot: false,
      type: 'input',
      cards: [],
      validation: {
        required: true,
        minLength: 3,
        maxLength: 5000,
      },
    },
    {
      id: 3,
      type: 'input',
      field: 'cardTitle',
      widthContainer: '100%',
      placeholder: 'Введите название заголовка для карточек',
      actions: ['update', 'delete'],
      inputValue: '',
      inputWidth: '600px',
      inputHeight: '50px',
      inputAppendText: '',
      inputAppendIcon: '',
      btnInner: false,
      btnInnerTitle: '',
      btnSlot: false,
      cards: [],
      validation: {
        required: true,
        minLength: 3,
        maxLength: 3000
      },
    },
    {
      id: 6,
      field: 'card',
      widthContainer: '100%',
      placeholder: 'Добавьте описание',
      actions: ['draggable', 'update', 'delete'],
      inputValue: '',
      inputWidth: '600px',
      inputHeight: '140px',
      inputAppendText: '',
      inputAppendIcon: '',
      inputType: 'textarea',
      btnInner: false,
      btnInnerTitle: '',
      btnSlot: false,
      type: 'card',
      cards: [
        {
          id: 1,
          image: '',
          imageBase64: '',
          description: '',
        },
        {
          id: 2,
          image: '',
          imageBase64: '',
          description: '',
        },
        {
          id: 3,
          image: '',
          imagebBse64: '',
          description: '',
        },
      ],
      validation: {
        type: 'card',
      },
    },
    {
      id: 7,
      field: 'callBack',
      widthContainer: '100%',
      placeholder: 'Введите текст',
      actions: ['draggable', 'update', 'delete'],
      inputValue: '',
      inputWidth: '776px',
      inputHeight: '44px',
      inputAppendText: '',
      inputAppendIcon: '',
      btnInner: true,
      btnInnerTitle: 'Связаться с менеджером',
      btnSlot: false,
      type: 'input',
      cards: [],
      validation: {
        required: true,
        minLength: 3,
        maxLength: 1000
      },
    },
    {
      id: 8,
      field: 'price',
      type: 'input',
      widthContainer: '100%',
      placeholder: 'Добавьте стоимость',
      actions: ['draggable', 'update', 'delete'],
      inputType: 'number',
      inputValue: '',
      inputWidth: '263px',
      inputHeight: '40px',
      inputAppendText: '₽',
      inputAppendIcon: '',
      btnInner: false,
      btnInnerTitle: '',
      btnSlot: false,
      cards: [],
      validation: {
        required: false,
        maxLength: 100
      },
    },
    {
      id: 9,
      field: 'sale',
      type: 'input',
      widthContainer: '100%',
      placeholder: 'Добавьте размер скидки',
      actions: ['draggable', 'update', 'delete'],
      inputType: 'number',
      inputValue: '',
      inputWidth: '263px',
      inputHeight: '40px',
      inputAppendText: '₽',
      inputAppendIcon: '',
      btnInner: false,
      btnInnerTitle: '',
      btnSlot: false,
      cards: [],
      validation: {
        required: false,
        maxLength: 100
      },
    },
    {
      id: 10,
      field: 'report_preview',
      widthContainer: '100%',
      placeholder: '',
      actions: ['update', 'delete'],
      inputValue: '',
      inputWidth: '',
      inputHeight: '',
      inputAppendText: '',
      inputAppendIcon: '',
      btnInner: false,
      btnInnerTitle: '',
      preview: {},
      previewBase64: '',
      previewFile: {},
      previewFileBase64: '',
      btnSlot: false,
      type: 'uploadPreview',
      validation: {
        type: 'mainImage',
      },
    },
  ],
  successModalCreate: false,
  successModalUpdate: false,
  error: {},
});

export default {
  namespaced: true,
  state: initialState,

  actions: {
    async GET_ALL_SERVICES({ commit }) {
      try {
        commit('SET_LOADING', true);
        const reponse = await api.get('/service-catalog/service-cards/');
        if (Array.isArray(reponse) && reponse.length > 0) {
          commit('SET_SERVICES', reponse);
        }
      } catch (error) {
        return error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async GET_DETAIL_SERVICE({ commit }, id) {
      try {
        commit('SET_LOADING', true);
        const reponse = await api.get(`/service-catalog/service-cards/${id}/`);
        if (Object.entries(reponse).length > 0) {
          commit('SET_SERVICE_DETAIL', reponse);
        }
        return reponse;
      } catch (error) {
        commit('SET_ERROR', error);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    // <--------Создание услуги-------->

    // Создаем оболочку для карточки товара step 1
    async CREATE_SERVICE_CARD({ commit }, mainFieldCard) {
      try {
        commit('SET_LOADING', true);
        commit('SET_STEP_CREATING', { step: 1, finish: false });
        const response = await api.post('/service-catalog/service-cards/', mainFieldCard);
        commit('SET_STEP_CREATING', { step: 1, finish: true });
        return response;
      } catch (error) {
        commit('SET_STEP_CREATING', { step: 1, finish: false });
        return error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    // Создаем модули для карточки товара step 2
    async CREATE_MODULES({ commit }, payload) {
      try {
        commit('SET_LOADING', true);
        const data = {
          service_card: payload.card.id,
          module_type: payload.module.module_type, // main_image features contact_button report_preview
          text: payload.module.text || '',
          order: payload.module.order || 0,
        };
        if (data.service_card && data.module_type) {
          const response = await api.post('/service-catalog/service-card-modules/', data);
          commit('SET_STEP_CREATING', { step: 2, finish: true });
          return response;
        }
      } catch (error) {
        commit('SET_STEP_CREATING', { step: 2, finish: false });
        return error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    // Добавление в модуль изображения step 3
    async CREATE_IMAGES_BLOCK_FOR_MODULE({ commit }, module) {
      try {
        commit('SET_LOADING', true);
        const data = {
          module: module.id,
          caption: module.caption || '',
        };
        const response = await api.post('/service-catalog/module-images/', data);
        commit('SET_STEP_CREATING', { step: 3, finish: true });
        return response;
      } catch (error) {
        commit('SET_STEP_CREATING', { step: 3, finish: false });
        return error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    // Добавление в модуль изображения step 3
    async CREATE_FILES_BLOCK_FOR_MODULE({ commit }, module) {
      try {
        commit('SET_LOADING', true);
        const data = {
          module: module.id,
          caption: module.caption || '',
        };
        const response = await api.post('/service-catalog/module-files/', data);
        commit('SET_STEP_CREATING', { step: 3, finish: true });
        return response;
      } catch (error) {
        commit('SET_STEP_CREATING', { step: 3, finish: false });
        return error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    // Загрузка изображения в модуль step 4
    async UPLOAD_IMAGES_IN_MODULE({ commit }, payload) {
      try {
        commit('SET_LOADING', true);
        const response = await api.post(`/service-catalog/module-images/${payload.id}/upload/`, payload.formData);
        commit('SET_STEP_CREATING', { step: 4, finish: true });
        return response;
      } catch (error) {
        commit('SET_STEP_CREATING', { step: 4, finish: false });
        return error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async UPLOAD_FILES_IN_MODULE({ commit }, payload) {
      try {
        commit('SET_LOADING', true);
        const response = await api.post(`/service-catalog/module-files/${payload.id}/upload/`, payload.formData);
        commit('SET_STEP_CREATING', { step: 4, finish: true });
        return response;
      } catch (error) {
        commit('SET_STEP_CREATING', { step: 4, finish: false });
        return error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    // <--------Обновление услуги-------->

    // Обновляем оболочку для карточки товара step 1
    async UPDATE_SERVICE_CARD({ commit }, payload) {
      try {
        commit('SET_LOADING', true);
        commit('SET_STEP_CREATING', { step: 1, finish: false });
        const response = await api.patch(`/service-catalog/service-cards/${payload.id}/`, payload.mainFieldCard);
        commit('SET_STEP_CREATING', { step: 1, finish: true });
        return response;
      } catch (error) {
        commit('SET_STEP_CREATING', { step: 1, finish: false });
        return error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    // Обновляем модули для карточки товара step 2
    async UPDATE_MODULE({ commit }, payload) {
      try {
        commit('SET_LOADING', true);
        const data = {
          service_card: payload.card.id,
          module_type: payload.module.module_type, // main_image features contact_button report_preview
          text: payload.module.text || '',
          order: payload.module.order || 0,
        };
        if (data.service_card && data.module_type) {
          const response = await api.patch(`/service-catalog/service-card-modules/${payload.module.id}/`, data);
          commit('SET_STEP_CREATING', { step: 2, finish: true });
          return response;
        }
      } catch (error) {
        commit('SET_STEP_CREATING', { step: 2, finish: false });
        return error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    // Обновление модуля изображения step 3
    async UPDATE_IMAGES_BLOCK_FOR_MODULE({ commit }, module) {
      try {
        commit('SET_LOADING', true);
        const data = {
          module: module.cardId,
          caption: module.caption || '',
          cardId: module.id
        };
        const response = await api.patch(`/service-catalog/module-images/${data.cardId}/`, data);
        commit('SET_STEP_CREATING', { step: 3, finish: true });
        return response;
      } catch (error) {
        commit('SET_STEP_CREATING', { step: 3, finish: false });
        return error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    // <--------Удаление услуги-------->

    // Удаление услуги
    async DELETE_SERVICE({ commit }, payload) {
      try {
        commit('SET_LOADING', true);
        const response = await api.delete(`/service-catalog/service-cards/${payload.id}/`);
        return response;
      } catch (error) {
        throw new Error(error);
      } finally {
        commit('SET_LOADING', false);
      }
    },
    // Удаление модуля изображения
    async DELETE_MODULE_IMAGES({ commit }, payload) {
      try {
        commit('SET_LOADING', true);
        const response = await api.delete(`/service-catalog/module-images/${payload.id}/`);
        return response;
      } catch (error) {
        throw new Error(error);
      } finally {
        commit('SET_LOADING', false);
      }
    },
    // Удаление модуля файла
    async DELETE_MODULE_FILES({ commit }, payload) {
      try {
        commit('SET_LOADING', true);
        const response = await api.delete(`/service-catalog/module-files/${payload.id}/`);
        return response;
      } catch (error) {
        throw new Error(error);
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async PUBLISHED_SERVICE(_, payload) {
      try {
        await api.post(`/service-catalog/service-cards/${payload.id}/publish/`, {});
      } catch (error) {
        return error;
      }
    },
    async UN_PUBLISHED_SERVICE(_, payload) {
      try {
        await api.post(`/service-catalog/service-cards/${payload.id}/unpublish/`, {});
      } catch (error) {
        return error;
      }
    },
    async CHANGE_ORDER_SERVICE({ commit }, payload) {
      try {
        commit('SET_LOADING', true);
        await api.patch(`/service-catalog/service-cards/${payload.id}/`, payload);
      } catch (error) {
        return error;
      } finally {
        commit('SET_LOADING', false);
      }
    }
  },
  mutations: {
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_SERVICES(state, services) {
      state.services = services;
    },
    SET_SERVICE_CREATING(state, serviceCreating) {
      state.serviceCreating = serviceCreating;
    },
    SET_CREATE_SERVICE_DETAIL(state, serviceCreatingDetails) {
      state.serviceCreatingDetails = serviceCreatingDetails;
    },
    SET_SERVICE_DETAIL(state, serviceCreatingDetails) {
      state.serviceDetailPreview = serviceCreatingDetails;
    },
    SET_BASE_FIELDS(state, fields) {
      state.baseFieldService = fields;
    },

    // SET ERROR
    SET_ERROR(state, error) {
      state.error = error;
    },

    // STEP CREATING
    SET_STEP_CREATING(state, stepCreating) {
      state.stepCreating = stepCreating;
    },

    SET_SUCCESS_MODAL_CREATE(state, success) {
      state.successModalCreate = success;
    },

    SET_SUCCESS_MODAL_UPDATE(state, success) {
      state.successModalUpdate = success;
    },

    CLEAR_BASE_FIELDS(state) {
      state.baseFieldService = [
        {
          id: 1,
          type: 'input',
          field: 'mainTitle',
          widthContainer: '100%',
          placeholder: 'Введите название заголовка',
          actions: ['update', 'delete'],
          inputValue: '',
          inputWidth: '600px',
          inputHeight: '50px',
          inputAppendText: '',
          inputAppendIcon: '',
          btnInner: false,
          btnInnerTitle: '',
          btnSlot: false,
          cards: [],
          validation: {
            required: true,
            minLength: 3,
            maxLength: 3000
          },
        },
        {
          id: 2,
          type: 'input',
          field: 'shortDescription',
          widthContainer: '63%',
          placeholder: 'Добавьте краткое описание',
          actions: ['draggable', 'update', 'delete'],
          inputValue: '',
          inputWidth: '600px',
          inputHeight: '82px',
          inputAppendText: '',
          inputAppendIcon: '',
          btnInner: false,
          btnInnerTitle: '',
          btnSlot: true,
          cards: [],
          validation: {
            required: true,
            minLength: 3,
            maxLength: 3000
          },
        },

        {
          id: 4,
          field: 'mainImage',
          widthContainer: '35%',
          placeholder: '',
          actions: ['update', 'delete'],
          inputValue: '',
          inputWidth: '',
          inputHeight: '',
          inputAppendText: '',
          inputAppendIcon: '',
          btnInner: false,
          btnInnerTitle: '',
          mainImage: { },
          mainImageBase64: '',
          btnSlot: false,
          type: 'upload',
          validation: {
            type: 'mainImage',
          },
        },
        {
          id: 5,
          field: 'fullDescription',
          widthContainer: '100%',
          placeholder: 'Добавьте подробное описание',
          actions: ['draggable', 'update', 'delete'],
          inputValue: '',
          inputWidth: '776px',
          inputHeight: '82px',
          inputAppendText: '',
          inputAppendIcon: '',
          btnInner: false,
          btnInnerTitle: '',
          btnSlot: false,
          type: 'input',
          cards: [],
          validation: {
            required: true,
            minLength: 3,
            maxLength: 3000
          },
        },
        {
          id: 3,
          type: 'input',
          field: 'cardTitle',
          widthContainer: '100%',
          placeholder: 'Введите название заголовка для карточек',
          actions: ['update', 'delete'],
          inputValue: '',
          inputWidth: '600px',
          inputHeight: '50px',
          inputAppendText: '',
          inputAppendIcon: '',
          btnInner: false,
          btnInnerTitle: '',
          btnSlot: false,
          cards: [],
          validation: {
            required: true,
            minLength: 3,
            maxLength: 3000
          },
        },
        {
          id: 6,
          field: 'card',
          widthContainer: '100%',
          placeholder: 'Добавьте описание',
          actions: ['draggable', 'update', 'delete'],
          inputValue: '',
          inputWidth: '600px',
          inputHeight: '140px',
          inputAppendText: '',
          inputAppendIcon: '',
          btnInner: false,
          btnInnerTitle: '',
          btnSlot: false,
          type: 'card',
          cards: [
            {
              id: 1,
              image: '',
              imageBase64: '',
              description: '',
            },
            {
              id: 2,
              image: '',
              imageBase64: '',
              description: '',
            },
            {
              id: 3,
              image: '',
              imagebBse64: '',
              description: '',
            },
          ],
          validation: {
            type: 'card',
          },
        },
        {
          id: 7,
          field: 'callBack',
          widthContainer: '100%',
          placeholder: 'Введите текст',
          actions: ['draggable', 'update', 'delete'],
          inputValue: '',
          inputWidth: '776px',
          inputHeight: '44px',
          inputAppendText: '',
          inputAppendIcon: '',
          btnInner: true,
          btnInnerTitle: 'Связаться с менеджером',
          btnSlot: false,
          type: 'input',
          cards: [],
          validation: {
            required: true,
            minLength: 3,
            maxLength: 3000
          },
        },
        {
          id: 8,
          field: 'price',
          type: 'input',
          widthContainer: '100%',
          placeholder: 'Добавьте стоимость',
          actions: ['draggable', 'update', 'delete'],
          inputType: 'number',
          inputValue: '',
          inputWidth: '263px',
          inputHeight: '40px',
          inputAppendText: '₽',
          inputAppendIcon: '',
          btnInner: false,
          btnInnerTitle: '',
          btnSlot: false,
          cards: [],
          validation: {
            required: false,
            maxLength: 3000
          },
        },
        {
          id: 9,
          field: 'sale',
          type: 'input',
          widthContainer: '100%',
          placeholder: 'Добавьте размер скидки',
          actions: ['draggable', 'update', 'delete'],
          inputType: 'number',
          inputValue: '',
          inputWidth: '263px',
          inputHeight: '40px',
          inputAppendText: '₽',
          inputAppendIcon: '',
          btnInner: false,
          btnInnerTitle: '',
          btnSlot: false,
          cards: [],
          validation: {
            required: false,
            maxLength: 3000
          },
        },
        {
          id: 10,
          field: 'report_preview',
          widthContainer: '100%',
          placeholder: '',
          actions: ['update', 'delete'],
          inputValue: '',
          inputWidth: '',
          inputHeight: '',
          inputAppendText: '',
          inputAppendIcon: '',
          btnInner: false,
          btnInnerTitle: '',
          preview: { },
          previewBase64: '',
          previewFile: {},
          previewFileBase64: '',
          btnSlot: false,
          type: 'uploadPreview',
          validation: {
          },
        },
      ];
    },

    SET_CURRENT_STEP_CREATING(state, stepName) {
      state.currentStepCreating = stepName;
    },
    CHANGE_STATUS_STEP_CREATING(state, payload) {
      const statusIdx = state.stepsCreating.findIndex(s => s.name === payload.name);
      if (statusIdx !== -1) {
        state.stepsCreating[statusIdx].status = payload.status;
        if (payload?.error) {
          state.stepsCreating[statusIdx].detailError.push(payload.error);
        }
      }
    },
    CHANGE_STATUS_STEP_CREATING_MODULE(state, payload) {
      const statusIdx = state.stepsCreating.findIndex(s => s.name === 'createModules');
      const moduleIdx = state.stepsCreating[statusIdx].modules.findIndex(s => s.name === payload.name);
      if (statusIdx !== -1) {
        state.stepsCreating[statusIdx].modules[moduleIdx].status = payload.status;
        if (payload?.error) {
          state.stepsCreating[statusIdx].modules[moduleIdx].error.push(payload.error);
        }
      }
    },
    CLEAR_STEP_CREATING(state) {
      state.stepsCreating = [
        {
          id: 0,
          name: 'InitializationCreating',
          text: 'Инициализация создания карточки услуги',
          status: 'notStarted', // [notStarted,started,finished,error]
          detailError: [],
        },
        {
          id: 1,
          name: 'createBaseCard',
          text: 'Создание базовой карточки',
          status: 'notStarted', // [notStarted,started,finished,error]
          detailError: [],
        },
        {
          id: 2,
          name: 'createModules',
          text: 'Создание модулей',
          status: 'notStarted', // [notStarted,started,finished,error]
          modules: [
            {
              id: 0,
              availability: true,
              name: 'main_image',
              text: 'Модуль главного изображения',
              status: 'notStarted',
              error: [],
            },
            {
              id: 1,
              availability: true,
              name: 'features',
              text: 'Модуль особенностей',
              status: 'notStarted',
              error: [],
            },
            {
              id: 2,
              availability: true,
              name: 'contact_button',
              text: 'Модуль контактной кнопки',
              status: 'notStarted',
              error: [],
            },
            {
              id: 3,
              availability: true,
              name: 'report_preview',
              text: 'Модуль превью',
              status: 'notStarted',
              error: [],
            },
          ],
          detailError: [],
        },
      ];
    }
  },
  getters: {
    GET_ALL_SERVICES: (state) => state.services,
    GET_SERVICE_CREATING: (state) => state.serviceCreating,
    GET_SERVICE_CREATING_DETAILS: (state) => state.serviceCreatingDetails,
    GET_DETAIL_SERVICE_PREVIEW: (state) => state.serviceDetailPreview,
    GET_SERVICE_DETAIL_REPORT_SAMPLE: (state) => {
      if (!state.serviceDetailPreview.modules || state.serviceDetailPreview.modules.length === 0) {
        return null;
      }

      return state.serviceDetailPreview.modules.find(module =>
        module.module_type === 'report_preview'
      );
    },
    GET_LOADING_SERVICES: (state) => state.loading,
    GET_ERROR_STATE: (state) => state.error,
    GET_SUCCESS_MODAL_UPDATE: (state) => state.successModalUpdate,
    GET_SUCCESS_MODAL_CREATE: (state) => state.successModalCreate,
    GET_BASE_FIELDS: (state) => state.baseFieldService,
    GET_CURRENT_STEP_CREATING: (state) => state.currentStepCreating,
    GET_STEPS_CREATING: (state) => state.stepsCreating,
  },
};
